(() => {
  function init(root) {
    if (!root || root.dataset.tabsGridInitialized === "true") return;
    root.dataset.tabsGridInitialized = "true";

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      tabs.forEach(t => {
        const selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
      });

      panels.forEach(p => {
        p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
      });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (e) => {
        const i = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const next = tabs[i + 1] || tabs[0];
          next.focus();
          activateTab(next);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = tabs[i - 1] || tabs[tabs.length - 1];
          prev.focus();
          activateTab(prev);
        }
      });
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-collection-tabs-grid-root]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
})();
